export const painBanks = [
  {
    label: "Danske Bank",
    value: "Danske Bank",
  },
  {
    label: "Handelsbanken",
    value: "Handelsbanken",
  },
  {
    label: "ICA Banken",
    value: "ICA Banken",
  },
  {
    label: "Länsförsäkringar",
    value: "Länsförsäkringar",
  },
  {
    label: "Nordea",
    value: "Nordea",
  },
  {
    label: "SBAB",
    value: "SBAB",
  },
  {
    label: "SEB",
    value: "SEB",
  },
  {
    label: "Skandiabanken",
    value: "Skandiabanken",
  },
  {
    label: "Sparbanken Syd",
    value: "Sparbanken Syd",
  },
  {
    label: "Sparbankerna",
    value: "Sparbankerna",
  },
  {
    label: "Swedbank",
    value: "Swedbank",
  },
];
